module.exports = __webpack_public_path__ + "img/mate-card_mrspelik.2f9198e.png";